import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {Paginator} from "../../../tools/pagination/paginator";

@Component({
  selector: 'app-paginator',
  imports: [
    NgForOf,
    NgClass,
    NgIf
  ],
  templateUrl: './paginator.component.html',
  styleUrl: './paginator.component.scss'
})
export class PaginatorComponent {

  @Input() paginator: Paginator | null = null;
  @Output() pageChange = new EventEmitter();

  getPages(): number[] {
    let pages = [];

    if (this.paginator) {
      let pageMin = Math.max(this.paginator.currentPage - 5, 1);
      let pageMax = Math.min(this.paginator.currentPage + 5, this.paginator.pageCount);
      for (let i = pageMin; i <= pageMax; i++) {
        pages.push(i);
      }
    }

    return pages;
  }

  changePage(event: Event, page: number): void {
    event.preventDefault();
    if (this.paginator) {
      this.paginator.currentPage = page;
    }
    this.pageChange.emit(page);
  }

  isCurrentPage(page: number): boolean {
    return !!(this.paginator && this.paginator.currentPage == page);
  }

  getNextPage(): number {
    if (this.paginator && this.paginator.currentPage < this.paginator.pageCount) {
      return this.paginator.currentPage + 1;
    }

    return 0;
  }

  getPreviousPage(): number {
    if (this.paginator && this.paginator.currentPage > 1) {
      return this.paginator.currentPage - 1;
    }

    return 0;
  }
}
